{
  "es": {
    "signature": {
      "actions": {
        "clearSignature": "Limpiar firma",
        "edit": "Editar",
        "request": "Solicitar firma",
        "save": "Guardar",
        "sign": "Firmar"
      },
      "labels": {
        "add": "Añadir",
        "add_customer_signatures": "Debes añadir las firmas de los clientes antes de guardar.",
        "add_team_member_signatures": "Debes añadir las firmas de los miembros del equipo antes de guardar.",
        "all_customers_signed": "Todos los clientes solicitados ya han firmado. Los documentos todavía deben firmarlos los representantes de {client_name}, y la propuesta se aprobará en cuanto los firmen. No es necesaria ninguna otra acción por tu parte.",
        "browserNotSupported": "Hemos detectado que es posible que tu navegador móvil no admita firmas electrónicas. Si tienes algún problema, cambia de navegador o de dispositivo, o sube un documento ya firmado.",
        "customer_signatories": "Firmantes del cliente",
        "customers_left_to_sign": "1 cliente debe firmar | {customers_left_to_sign} clientes deben firmar",
        "customers_required_to_sign": "Falta 1 cliente más por firmar los documentos. | Faltan {customers_left_to_sign} clientes más por firmar los documentos.",
        "customers_signed_names": "Clientes que ya han firmado: {names}",
        "document_image_data_error": "Error al cargar los datos de la imagen del documento.",
        "document_load_error": "No se ha podido cargar el documento. Comprueba que el archivo sea válido.",
        "document_url_missing_error": "Falta la URL del documento.",
        "documents_to_sign": "Documentos por firmar",
        "draw_signature": "Dibuja tu firma a continuación",
        "employee_signatories": "Firmantes de {client_name}",
        "employees_signed_names": "Miembros del equipo que ya han firmado: {names}",
        "empty_signature_warning": "Dibuja tu firma primero.",
        "marked": "Posición de la firma marcada",
        "next": "Siguiente",
        "no_signature_indicators_warning": "Indica dónde debe firmarse el documento haciendo clic en la página o páginas.",
        "ok": "Aceptar",
        "original": "Original",
        "page": "página",
        "place_signature_subtitle": "Haz clic en la página o páginas donde el cliente debe firmar electrónicamente",
        "place_signature_title": "Marca dónde firmar",
        "read_and_sign": "He leído y deseo firmar",
        "read_documents": "Lee los siguientes documentos antes de firmarlos",
        "remove": "Eliminar",
        "requesting_signage": "Solicitando firma a",
        "save_error": "Se ha producido un error al guardar.",
        "sign": "Firmar",
        "signatories_for_all_documents": "El número de firmantes se aplica a todos los documentos. Cambiarlo eliminará todas las firmas y tendrás que añadirlas de nuevo.",
        "signatureNotPossible": "Las firmas electrónicas no están disponibles para este tipo de archivo",
        "signatureNotPossibleSize": "Las firmas electrónicas no están disponibles para archivos de más de 40 MB",
        "signatures_pending_from_client": "Firmas pendientes del equipo de {client_name}",
        "signed": "Firmado",
        "signed_progress": "Firmado: {already_signed_count} de {all_required_to_sign_count}",
        "specifyWhereToSign": "Marca dónde firmar",
        "team_member": "Empleado",
        "team_member_signature_warning": "Podrás solicitar la firma a los miembros del equipo después de haberla solicitado a los clientes.",
        "thank_you_for_signing": "Gracias por firmar.",
        "toBeSigned": "Por firmar",
        "troubleSigningUpload": "¿Problemas para firmar? Sube un documento ya firmado en su lugar"
      }
    }
  }
}
